import { MOON_RETROGRADES, getPlanetImage, formatMoonDate } from "../../config/moon-content"
import type { MoonRetrogradeItem } from "../../types"

interface PlanetaryRetrogradesProps {
  retrogrades?: MoonRetrogradeItem[]
}

/** Planetary retrogrades horizontal slider. Ported from MoonPhase PlanetaryRetrogrades. */
export function PlanetaryRetrogrades({ retrogrades }: PlanetaryRetrogradesProps) {
  const cards = (retrogrades ?? []).map((item) => ({
    planet: item.planet,
    title: item.title,
    description: item.description,
    startDate: item.start_date,
    endDate: item.end_date,
  }))

  return (
    <div className="mt-10 w-full">
      <div className="flex flex-col gap-2 px-4">
        <h3 className="font-display text-2xl font-medium text-purple-light">
          {MOON_RETROGRADES.title}
        </h3>
        <p className="font-body text-base text-purple-light/70">{MOON_RETROGRADES.description}</p>
      </div>

      <div className="mt-6 flex items-stretch gap-4 overflow-x-auto px-4 [scrollbar-width:none]">
        {cards.length === 0 && (
          <div className="w-full rounded-3xl bg-gradient-to-bl from-purple-light/10 to-purple-light/5 px-4 py-6">
            <p className="font-body text-base text-purple-light/70">
              No active planetary retrogrades today.
            </p>
          </div>
        )}
        {cards.map((card) => {
          const image = getPlanetImage(card.planet)
          return (
            <div
              key={card.title}
              className="flex w-80 min-w-80 flex-col gap-4 rounded-3xl bg-gradient-to-bl from-purple-light/10 to-purple-light/5 px-4 pb-6 pt-4"
            >
              <div className="flex size-14 min-w-14 items-center justify-center rounded-full bg-purple-light/10">
                {image && <img src={image} alt={card.planet} className="size-9 min-w-9" />}
              </div>
              <div className="flex w-full flex-col gap-2">
                <h4 className="font-display text-xl font-medium text-purple-light">{card.title}</h4>
                <p className="font-body text-base text-purple-light/70">{card.description}</p>
              </div>
              <div className="mt-auto w-fit rounded-[23px] border border-purple-light/20 px-3 py-1.5">
                <span className="whitespace-nowrap font-body text-sm font-medium text-purple-light">
                  {formatMoonDate(card.startDate, false)} - {formatMoonDate(card.endDate, false)}
                </span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
